import React from 'react'
import errorState from '../../images/coffee-error.png'

function ErrorIcon() {
  return <img src={errorState} alt="café derramado indicando um erro" />
}

export default ErrorIcon
